import { put, takeLatest } from 'redux-saga/effects';
import { FieldSectionType } from 'api/field-sections/types';
import { TaskAPI } from 'api/tasks';
import { STATUS_FIELD_NAME } from 'data/fields/hooks/account-fields';
import { ACCOUNT_CONFIG_QUERY_KEY } from 'queries/account';
import { getProjectDependencyMapKey } from 'queries/common';
import { logger } from 'services';
import { invalidateTaskQuery } from 'utils/invalidate-task-query';
import { createMultipleSubTasksSagaAction } from '../actions';
import { addMultipleSubTasksToTask, createMultipleTaskSuccess } from '../slice';
function* createMultipleSubTasksSaga(action) {
    var _accountConfig_fields, _statusField_metaData;
    const { payload } = action;
    const { projectId, queryClient, ...rest } = payload;
    const accountConfig = queryClient.getQueryData(ACCOUNT_CONFIG_QUERY_KEY);
    const statusField = accountConfig === null || accountConfig === void 0 ? void 0 : (_accountConfig_fields = accountConfig.fields) === null || _accountConfig_fields === void 0 ? void 0 : _accountConfig_fields.find((f)=>f.fieldName === STATUS_FIELD_NAME && f.objectType === FieldSectionType.Task);
    if (!statusField) {
        return;
    }
    const { fieldId } = statusField;
    const fieldValue = (_statusField_metaData = statusField.metaData) === null || _statusField_metaData === void 0 ? void 0 : _statusField_metaData.default;
    try {
        yield put(addMultipleSubTasksToTask({
            projectId,
            parentTask: rest.parentTask,
            subtasks: rest.subtasks,
            fields: [
                {
                    fieldId,
                    fieldValue
                }
            ]
        }));
        const tasks = yield TaskAPI.addMultipleSubtasks(rest.parentTask, rest.subtasks.map((e)=>({
                taskName: e.taskName
            })));
        yield queryClient.invalidateQueries(getProjectDependencyMapKey(projectId));
        yield put(createMultipleTaskSuccess({
            projectId,
            subtasks: rest.subtasks,
            tasks
        }));
        yield invalidateTaskQuery(rest.parentTask);
    } catch (error) {
        logger.error('createSubTaskSaga failed', {
            error
        });
    }
}
export function* watchCreateMultipleSubTaskSaga() {
    yield takeLatest(createMultipleSubTasksSagaAction.type, createMultipleSubTasksSaga);
}
